<template>
  <div
    v-if="!!modal"
    v-show="ready"
    class="text-center max-w-modal rounded-loose shadow-modal mb-5 mx-5"
    :style="style"
  >
    <div class="flex items-center justify-between p-3 lg:p-5">
      <div />
      <h2 class="text-1-mob lg:text-3-desk uppercase font-title">
        {{ heading }}
      </h2>
      <CoreIcon
        class="cursor-pointer"
        @click="handleClose"
        icon="close"
        :color="modal.fgColor"
        :width="isMobile ? 12 : 20"
      >
        <IconClose />
      </CoreIcon>
    </div>
    <div
      class="text-5-mob lg:text-6-desk px-6 pb-6 lg:px-16 lg:pb-16 font-body text-center"
    >
      <p v-if="modal.content.type === 'text'">{{ content }}</p>
      <Component v-else :is="content" />
    </div>
  </div>
</template>

<script>
import { mapState } from "vuex";
import { isFunction } from "@utils/types";
import { colors } from "@utils/tailwind";
import { globals } from "@io/global";
import BlockSignUp from "./BlockSignUp";
import BlockInstagram from "./BlockInstagram";
import BlockEmail from "./BlockEmail";
import BlockCookies from "./BlockCookies";
import { IconClose } from "@c/Icon";

const globalText = (group, key) => () =>
  globals() ? globals()[group][key] : "";

export const welcome = {
  bgColor: "pink",
  fgColor: "teal",
  heading: globalText("welcome", "heading"),
  content: {
    type: "text",
    value: globalText("welcome", "text")
  }
};

export const cookies = {
  bgColor: "teal",
  fgColor: "pink",
  heading: "WE USE COOKIES",
  content: {
    type: "component",
    value: "BlockCookies"
  }
};

export const instagram = {
  bgColor: "yellow",
  fgColor: "rust",
  heading: globalText("instagram", "heading"),
  content: {
    type: "component",
    value: "BlockInstagram"
  }
};

export const mailingList = {
  bgColor: "rust",
  fgColor: "yellow",
  heading: globalText("mailingList", "heading"),
  content: {
    type: "component",
    value: "BlockSignUp"
  }
};

export const contact = {
  bgColor: "red",
  fgColor: "pink",
  heading: globalText("contact", "heading"),
  content: {
    type: "component",
    value: "BlockEmail"
  }
};

export default {
  name: "BlockModal",

  components: {
    BlockSignUp,
    BlockInstagram,
    BlockEmail,
    BlockCookies,
    IconClose
  },

  props: {
    modal: {
      type: Object
    }
  },

  data: () => ({
    ready: false
  }),

  computed: {
    ...mapState({
      isMobile: state => state.ui.isMobile
    }),
    heading() {
      if (!this.modal) return "";

      const { heading } = this.modal;
      return isFunction(heading) ? heading() : heading;
    },
    content() {
      if (!this.modal) return "";

      const {
        content: { value }
      } = this.modal;

      return isFunction(value) ? value() : value;
    },
    style() {
      return {
        backgroundColor: colors[this.modal.bgColor],
        color: colors[this.modal.fgColor]
      };
    }
  },

  watch: {
    content: {
      immediate: true,
      handler(val) {
        if (val !== "") this.ready = true;
      }
    }
  },

  methods: {
    handleClose() {
      this.$store.commit("removeModal", this.modal.uuid);
    }
  }
};
</script>
